import $ from 'jquery'
import { alert_error, post_json, get_json, eval_html_template,
         get_myinfo, has_user_loggedin, utf8hex_to_string } from '../../common'
import * as qs from 'querystring'

$(init)

async function init () {
  let $page = $('#unsubscribe-page')
  if ($page.length == 0) {
    return
  }
  try {
    let query = qs.parse(location.search.substring(1))
    let is_valid = true
    let email
    try {
      email = utf8hex_to_string(query.u||'')
    }  catch (err) {
      is_valid = false
    }
    if (!is_valid) {
      $page.find('.invalid-msg').removeClass('d-none')
      $page.find('.unsubscribe-form').addClass('d-none')
    } else {
      let from_list = (query.unsubfrom||'').split(',')
      $page.find('[name=marketing_emails]').prop('checked', from_list.indexOf('marketing') != -1)
      $page.find('[name=notification_emails]').prop('checked', from_list.indexOf('notification') != -1)
    }
    $page.removeClass('page-not-ready').addClass('page-ready')
    $page.find('.unsubscribe-form').on('submit', async ($evt) => {
      $evt.preventDefault()
      $page.find('.unsubscribe-form button').prop('disabled', true)
      try {
        let from_list = []
        if ($page.find('[name=marketing_emails]').prop('checked')) {
          from_list.push('marketing')
        }
        if ($page.find('[name=notification_emails]').prop('checked')) {
          from_list.push('notification')
        }
        if (from_list.length == 0) {
          alert_error({ title: 'Input error', message: 'Please select at least one list you would like to unsubscribe from.' })
          return
        }
        await post_json('users/unsubscribe', { email, token: query.t, unsubfrom: from_list.join(',') })
        $page.find('.unsubscribe-form').addClass('d-none')
        $page.find('.success-msg').removeClass('d-none')
      } catch (err) {
        alert_error(err)
      } finally {
        $page.find('.unsubscribe-form button').prop('disabled', false)
      }
    })
  } catch (err) {
    alert_error(err)
  }
}
